import { ref, getBlob } from "firebase/storage";
import { store } from "shared/api/firebase";

export const getImageFile = async (imagePath: string) => {
  const fileRef = ref(store, imagePath);

  try {
    const blob = await getBlob(fileRef);
    const file = new File([blob], "filename.png", { type: "image/png" });

    return file;
  } catch (error) {
    console.error("Error fetching image details:", error);
  }
};
